module.exports = __webpack_public_path__ + "img/2e3d887.jpg";